export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/whiteCheckmark.be2c03da.svg","height":13,"width":15,"blurWidth":0,"blurHeight":0};